// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-campaign-model {
  border-radius: 10px;
  background: #fff;
}
.share-campaign-model .ant-modal .ant-modal-content {
  position: relative;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-radius: 8px;
  box-shadow: none;
  pointer-events: auto;
  /* padding: 20px 30px; */
}

.share-camapign-model-header {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h5, 17px);
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.share-campaign-model-warn .share-campaign-text {
  flex-shrink: 0;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.share-campaign-cancel-btn {
  margin-right: 20px;
  display: inline-flex;
  height: 44px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 3px;
  background: #f0f0f0;
}

.share-campaign-send-btn {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: inline-flex;
  height: 44px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: none;
  background: var(--Colors-Primary-500, #d2042d);
}

.share-cancel {
  color: #0a0f0d;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-right: 15px;
}
.share-send {
  color: #fff;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.share-campaign-model .ant-typography a {
  color: var(--Colors-Primary-500, #d2042d);
  text-decoration-line: underline;
  font-size: 13px;
  font-weight: 400;
  outline: none;
  line-height: 24px;
  cursor: pointer;
  /* transition: all 0.3s; */
  border: 0;
  padding: 0;
  background: none;
  -webkit-user-select: text;
          user-select: text;
}
.recipient-input-field {
  height: 3.125rem;
  padding: 0.625rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 1rem;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/edit-campaign/EditCampaign.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;AAChC","sourcesContent":[".share-campaign-model {\n  border-radius: 10px;\n  background: #fff;\n}\n.share-campaign-model .ant-modal .ant-modal-content {\n  position: relative;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: none;\n  pointer-events: auto;\n  /* padding: 20px 30px; */\n}\n\n.share-camapign-model-header {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h5, 17px);\n  padding-bottom: 30px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.share-campaign-model-warn .share-campaign-text {\n  flex-shrink: 0;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.share-campaign-cancel-btn {\n  margin-right: 20px;\n  display: inline-flex;\n  height: 44px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  border-radius: 3px;\n  background: #f0f0f0;\n}\n\n.share-campaign-send-btn {\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  display: inline-flex;\n  height: 44px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 3px;\n  border: none;\n  background: var(--Colors-Primary-500, #d2042d);\n}\n\n.share-cancel {\n  color: #0a0f0d;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-right: 15px;\n}\n.share-send {\n  color: #fff;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.share-campaign-model .ant-typography a {\n  color: var(--Colors-Primary-500, #d2042d);\n  text-decoration-line: underline;\n  font-size: 13px;\n  font-weight: 400;\n  outline: none;\n  line-height: 24px;\n  cursor: pointer;\n  /* transition: all 0.3s; */\n  border: 0;\n  padding: 0;\n  background: none;\n  user-select: text;\n}\n.recipient-input-field {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 1rem;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
